export const EMERGENCY_CONTACT_FIELDS = {
    RELATIONSHIP_WITH_PATIENT: "relationWithPatient",
    CONTACT_NUMBER: "contactNumber",
    FIRSTNAME: "firstName",
    MIDDLENAME: "middleName",
    LASTNAME: "lastName",
    EMAIL: "email"
}